const $ = window.jQuery;

const init = () => {
	$( document ).ready( function() {
		let button = $( '.gform_button.button.spirit-button' );

		if ( button ) {
			button.on( 'click', updateSubmitButton );
		}

		function updateSubmitButton( e ) {
			e.preventDefault();

			let innerHTML = button.html();
			button.html( window.spinnerSVG );

			// setting slight delay so gravityforms still submits the form properly.
			setTimeout( function() {
				button.prop( 'disabled', true );
				button.addClass( 'spirit-button--loading' );
				button.attr( 'data-loader', 'true' );
			}, 200 );

			setTimeout( function() {
				button.prop( 'disabled', false );
				button.removeClass( 'spirit-button--loading' );
				button.attr( 'data-loader', '' );
				button.html( innerHTML );
			}, 6000 );

			setTimeout( function() {
				button.parents( 'form' ).submit();
			}, 100 );
		}
	} );
};

export default { init };
